import { INIT_AUTH } from './../constants/actionTypes'

const auth = tokenDetails => dispatch => {
  dispatch({
    type: INIT_AUTH,
    auth: tokenDetails
  })
}

export default auth
